module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "px-5 pt-5 mt-5 text-poppins-36"
  }, [_vm._v("Upload audio")]), _vm._v(" "), _vm._v("\n    >\n      "), (_vm.isPageReady) ? _c('div', [_c('div', [_c('track-uploader', {
    attrs: {
      "accept": ".mp3",
      "autoUpload": true,
      "album": _vm.album
    }
  })], 1), _vm._v(" "), (_vm.album.tracks.length) ? _c('div', {
    attrs: {
      "id": "album_info_section"
    }
  }, [_c('div', {
    staticClass: "album-info-section mx-5"
  }, [_vm._m(0), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": "",
      "album-content-info": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md8": ""
    }
  }, [_c('div', {
    staticClass: "dflex d-row"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Album Title\n                      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.name),
      expression: "album.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.album.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-15 upload-album-item"
  }, [_c('div', {
    staticClass: "w-25"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Genre\n                      ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.getters['genreSelector/genre'].name
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-15"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" BPM ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.bpm),
      expression: "album.bpm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "'1-999'"
    },
    domProps: {
      "value": (_vm.album.bpm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "bpm", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-album-key w-25 dflex gap-15"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" KEY ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-nail"
  }, [_c('div', {
    staticClass: "dropdown-head",
    on: {
      "click": function($event) {
        _vm.majorDropdown = true
      }
    }
  }, [(_vm.majorValue == 'major') ? _c('div', [_vm._v("Major")]) : (_vm.majorValue == 'minor') ? _c('div', [_vm._v("Minor")]) : _c('div', {
    staticClass: "text-dull"
  }, [_vm._v("Select")])]), _vm._v(" "), (_vm.majorDropdown) ? _c('div', [_c('div', {
    staticClass: "dropdown-overlay",
    on: {
      "click": function($event) {
        _vm.majorDropdown = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-body"
  }, [_c('div', {
    staticClass: "inline-block",
    on: {
      "click": function($event) {
        _vm.majorValue = 'major';
        _vm.majorDropdown = false;
        _vm.keyDropdown = true;
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "major",
      "name": "key",
      "value": "major"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "major"
    }
  }, [_vm._v("Major")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-block",
    on: {
      "click": function($event) {
        _vm.majorValue = 'minor';
        _vm.majorDropdown = false;
        _vm.keyDropdown = true;
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "minor",
      "name": "key",
      "value": "minor"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "minor"
    }
  }, [_vm._v("Minor")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label show-none"
  }, [_vm._v(" KEY ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-nail"
  }, [_c('div', {
    staticClass: "dropdown-head"
  }, [(_vm.keyValue == 'none') ? _c('div', {
    staticClass: "text-dull"
  }, [_vm._v("\n                              -\n                            ")]) : _c('div', [_vm._v("\n                              " + _vm._s(_vm.keyValue) + "\n                            ")])]), _vm._v(" "), (_vm.keyDropdown) ? _c('div', [_c('div', {
    staticClass: "dropdown-body"
  }, _vm._l((_vm.keyOptions), function(index) {
    return _c('div', {
      staticClass: "cursor-pointer key-value",
      on: {
        "click": function($event) {
          _vm.setKeyValue(index);
          _vm.keyDropdown = false;
        }
      }
    }, [_vm._v("\n                                " + _vm._s(index) + "\n                              ")])
  }))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "w-30"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Location this album represents")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.locations,
      "item-text": "name",
      "item-value": "name",
      "placeholder": "Type name to search",
      "single-line": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.album.location),
      callback: function($$v) {
        _vm.$set(_vm.album, "location", $$v)
      },
      expression: "album.location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-15 upload-album-item"
  }, [_c('div', {
    staticClass: "w-25"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Released Date\n                      ")]), _vm._v(" "), _c('v-menu', {
    staticClass: "released-at-picker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px",
      "lazy": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.album.released_at),
      callback: function($$v) {
        _vm.$set(_vm.album, "released_at", $$v)
      },
      expression: "album.released_at"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": save
          }
        }, [_vm._v("OK")])], 1)]
      }
    }]),
    model: {
      value: (_vm.album.released_at),
      callback: function($$v) {
        _vm.$set(_vm.album, "released_at", $$v)
      },
      expression: "album.released_at"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-75"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Album includes\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "album-content-wrapper font-lable-check"
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Acapella",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_acapella),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_acapella", $$v)
      },
      expression: "album.is_content_acapella"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inst",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_instrumental),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_instrumental", $$v)
      },
      expression: "album.is_content_instrumental"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Stems",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_stems),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_stems", $$v)
      },
      expression: "album.is_content_stems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Remix",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_remix),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_remix", $$v)
      },
      expression: "album.is_content_remix"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "DJ Mix",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_dj_mix),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_dj_mix", $$v)
      },
      expression: "album.is_content_dj_mix"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dflex"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.description),
      expression: "album.description"
    }],
    staticClass: "album-description form-control non-resizable",
    domProps: {
      "value": (_vm.album.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "album-image-section pb-2"
  }, [_c('div', {
    staticClass: "image-section"
  }, [(_vm.album_image_url) ? _c('div', {
    staticClass: "album-image",
    style: (("background-image: url(" + _vm.album_image_url + ")")),
    attrs: {
      "id": "album_image"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.album_image_url) ? _c('div', {
    staticClass: "album-image-upload-section"
  }, [_c('input', {
    staticClass: "add-album-image-file",
    attrs: {
      "type": "file",
      "name": "album_image_file",
      "id": "album_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "album_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera mt-0"
  }, [_vm._v("photo_camera")]), _vm._v("upload\n                        ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "image-change-section"
  }, [_c('input', {
    staticClass: "change-album-image-file",
    attrs: {
      "type": "file",
      "name": "album_image_file",
      "id": "album_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), (_vm.album_image_url) ? _c('label', {
    attrs: {
      "for": "album_image_file"
    }
  }, [_vm._v("Change")]) : _vm._e()])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "album-info-section mx-5 pb-0"
  }, [_vm._m(1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "form-group": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Available to..\n                      ")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "py-0 my-0",
    attrs: {
      "items": _vm.access_levels,
      "name": "access_level",
      "item-text": "title",
      "item-value": "id",
      "chips": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('div', {
          staticClass: "custom-multi-select"
        }, [_c('span', [_vm._v(_vm._s(data.item.title))]), _vm._v(" "), _c('v-icon', {
          staticClass: "icon-close text-white"
        }, [_vm._v("\n                            close\n                          ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.album.access_level),
      callback: function($$v) {
        _vm.$set(_vm.album, "access_level", $$v)
      },
      expression: "album.access_level"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "album-info-section mx-5"
  }, [_vm._m(2), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": ""
    }
  }, [_c('v-flex', {
    staticClass: "additional-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "dflex": "",
      "align-center": "",
      "pa-0": "",
      "my-0": ""
    }
  }, [_c('h4', {
    staticClass: "album-info-title-x mb-0 mr-2"
  }, [_vm._v("\n                            Collaborators (" + _vm._s(_vm.collaborators.length) + ")\n                          ")]), _vm._v(" "), (_vm.collaborators.length < 3) ? _c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, _vm._l((_vm.collaborators), function(collaborator, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-album-collaborator mb-3"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "display-flex": "",
        "justify-start": "",
        "align-center": "",
        "gap-15": "",
        "mb-2": ""
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "src": "/static/images/track-example.png",
        "width": "62",
        "height": "62"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w-100"
    }, [_c('label', {
      staticClass: "control-label mb-0"
    }, [_vm._v("Track")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Owner")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "item-text": "owner",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No artist found",
        "autocomplete": ""
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Role")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Type name to search",
        "autocomplete": ""
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborator")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.potential_collaborators,
        "item-text": "username",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No artist found",
        "autocomplete": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                                  " + _vm._s(data.item.username) + "\n                                ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Role")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.role_types,
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Type name to search",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_role),
        callback: function($$v) {
          _vm.$set(collaborator, "user_role", $$v)
        },
        expression: "collaborator.user_role"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-15",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("\n                                clear\n                              ")])], 1)])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "additional-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "dflex": "",
      "align-center": "",
      "pa-0": "",
      "my-0": ""
    }
  }, [_c('h4', {
    staticClass: "album-info-title-x mb-0 mr-2"
  }, [_vm._v("\n                            Album Credits (" + _vm._s(_vm.contributors.length) + ")\n                          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addContributor()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, _vm._l((_vm.contributors), function(contirbutor, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" Contributor ")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.potential_contributors,
        "item-text": "username",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No user found",
        "autocomplete": "",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                                " + _vm._s(data.item.username) + "\n                              ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (contirbutor.user_id),
        callback: function($$v) {
          _vm.$set(contirbutor, "user_id", $$v)
        },
        expression: "contirbutor.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" Role ")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.role_types,
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Type name to search",
        "autocomplete": ""
      },
      model: {
        value: (contirbutor.user_role),
        callback: function($$v) {
          _vm.$set(contirbutor, "user_role", $$v)
        },
        expression: "contirbutor.user_role"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-4",
      on: {
        "click": function($event) {
          _vm.deleteContributor(index)
        }
      }
    }, [_vm._v("\n                              clear\n                            ")])], 1)])], 1)
  }))], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mx-5",
    attrs: {
      "xs12": "",
      "album-action-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm-6": "",
      "text-xs-left": "",
      "mb-5": ""
    }
  }, [_c('v-btn', {
    staticClass: "release-now-btn white--text",
    attrs: {
      "flat": "",
      "loading": _vm.loading,
      "disabled": _vm.slug ? !_vm.isAvailableToEditAlbum : !_vm.isAvailableToUploadAlbum
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseNow()
      }
    }
  }, [_vm._v("\n                  Release\n                ")]), _vm._v(" "), (false) ? _c('v-btn', {
    staticClass: "save-for-later-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveForLater()
      }
    }
  }, [_vm._v("\n                  Save for later\n                ")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1 large"
    },
    model: {
      value: (_vm.show_sample_clearance_license_modal),
      callback: function($$v) {
        _vm.show_sample_clearance_license_modal = $$v
      },
      expression: "show_sample_clearance_license_modal"
    }
  }, [_c('sample-license-dialog', {
    attrs: {
      "dismiss": _vm.closeSampleClearanceLicenseModal
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-genre-dialog ma-0 pa-2"
    },
    model: {
      value: (_vm.show_genre_selector_dialog),
      callback: function($$v) {
        _vm.show_genre_selector_dialog = $$v
      },
      expression: "show_genre_selector_dialog"
    }
  }, [_c('genre-single-selector', {
    attrs: {
      "dismiss": _vm.closeGenreSelectorDialog
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title mt-2"
  }, [_vm._v("Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Collaborators")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe4a8388","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/upload_album.vue
// module id = 1879
// module chunks = 180